import { createAction } from '../util/index.js';

export const toggleVideoModal = createAction(
    'TOGGLE_VIDEO_MODAL',
    requestObject => requestObject
);

// Active Training Material Actions
export const FETCH_ACTIVE_TRAINING_MATERIAL_REQUESTED = 'FETCH_ACTIVE_TRAINING_MATERIAL_REQUESTED';
export const FETCH_ACTIVE_TRAINING_MATERIAL_SUCCESS = 'FETCH_ACTIVE_TRAINING_MATERIAL_SUCCESS';
export const FETCH_ACTIVE_TRAINING_MATERIAL_ERROR = 'FETCH_ACTIVE_TRAINING_MATERIAL_ERROR';

export const fetchActiveTrainingMaterial = createAction(
    FETCH_ACTIVE_TRAINING_MATERIAL_REQUESTED,
    () => ({})
);

export const fetchActiveTrainingMaterialSuccess = createAction(
    FETCH_ACTIVE_TRAINING_MATERIAL_SUCCESS,
    data => data
);

export const fetchActiveTrainingMaterialError = createAction(
    FETCH_ACTIVE_TRAINING_MATERIAL_ERROR,
    error => error
);